// extracted by mini-css-extract-plugin
module.exports = {"title":"_b8eb362","subtitle":"_7e3235d","content":"_c12b1a2"};